import { render, staticRenderFns } from "./myemoji.vue?vue&type=template&id=213119b2&scoped=true&"
import script from "./myemoji.vue?vue&type=script&lang=js&"
export * from "./myemoji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213119b2",
  null
  
)

export default component.exports